var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{attrs:{"with-credentials":"","action":_vm.action,"headers":_vm.uploadHeaders,"accept":_vm.fileTypes == null ? '' : _vm.fileTypes.join(','),"show-file-list":false,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"disabled":_vm.disabled,"before-upload":_vm.beforeUpload}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }